// The words a setup card and the KPI mapping table read in: the catalog's copy, the product's own
// metric names (the report metric catalog, as the Alerts list shows them), and `useFormat`'s
// numbers and dates — never a fixed locale.
import type { PreviewLabels } from '../service/orpheusFilePreviewPresentation'
import type { SetupLabels } from '../service/orpheusSetupCardPresentation'

import { useMetricCatalog } from '@/features/reports'
import { useI18n } from '@/shared/i18n'
import { useFormat } from '@/shared/lib/format'

export function useSetupLabels(): SetupLabels & PreviewLabels {
  const { t } = useI18n()
  const catalog = useMetricCatalog()
  const format = useFormat()
  return {
    t: (key, params) => (params ? t(key, params) : t(key)),
    metric: (field) => catalog.metricLabel(field),
    formatNumber: (value) => format.formatNumber(value),
  }
}
